import React from "react";
import { Footer, Problem, Very } from "../components";

const Task = () => {
  return (
    <>
      <Problem />
      <Footer />
    </>
  );
};

export default Task;
